import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ExtraCampaignsServiceProvider } from '../../api/extra-campaigns'

const ExtraCampaignsService = ExtraCampaignsServiceProvider()
const name = 'codesDeleteAlternativeCampaign'

export default (id) => (asyncAction(
  name,
  ExtraCampaignsService.codesDeleteAlternativeCampaign,
  { id }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/extra-campaign/codesDeleteAlternativeCampaign.js